import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA-9wUrq_CywgUVfGLLOIGbP8SYqC1n8vo",
  authDomain: "danny-app-898a5.firebaseapp.com",
  projectId: "danny-app-898a5",
  storageBucket: "danny-app-898a5.firebasestorage.app",
  messagingSenderId: "243049138997",
  appId: "1:243049138997:web:9e7789c6d109f3b1269a7c"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);